import { useCallback, useMemo } from "react"
import { getCompositions, getPlayersPositions } from "../../api/index.js"
import { useFetch } from "../../filters/useFetch.js"

export const useCompositionListFeuilleMatch = (discipline) => {

    // Dispatch pour récupérer les positions

    const URLgetCompositions = useCallback(() => {

        return getCompositions(discipline)

    }, [discipline])

    const filters = useMemo(()  => {
        return {}

    }, [])


    const [compositions, loading] = useFetch(URLgetCompositions, filters, undefined, '')

    return [compositions]

}